import { TabToggle } from "#components";
import { AdminLayout } from "#layouts";
import React, { useState } from "react";
import TermsConditionsComponent from "./contentComponent/termsConditions";
import PrivacyPolicyComponent from "./contentComponent/privacyPolicy";
import AboutUsComponent from "./contentComponent/aboutUs";

const ContentManagement = () => {
  const [activeTab, setActiveTab] = useState("Terms & Conditions");

  // Function to handle tabActive
  const handleTabClick = (tabName) => {
    setActiveTab(tabName);
  };
  const renderComponent = () => {
    if (activeTab === "Terms & Conditions") {
      return <TermsConditionsComponent />;
    } else if (activeTab === "Privacy Policy") {
      return <PrivacyPolicyComponent />;
    } else if (activeTab === "About Us") {
      return <AboutUsComponent />;
    } else return null;
  };

  return (
    <AdminLayout>
      <section className="main-section spacer">
        <div className="container">
          <div className="row mt-4">
            <div className="col-xl-12">
              <div className="flex-between">
                <TabToggle
                  data={["Terms & Conditions", "Privacy Policy", "About Us"]}
                  activeTab={activeTab}
                  handleTabClick={handleTabClick}
                />
              </div>
              <div className="tab-content pt-4">
                <div className="tab-pane fade show active">
                  {renderComponent()}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </AdminLayout>
  );
};

export default ContentManagement;
